import { NewClient } from './NewClient'
import { NewPet } from './NewPet'

export const New = {
  Client: NewClient,
  Pet: NewPet,
}
